import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCode,
  setItemCountry,
  setItemRegion,
  setItemName,
  setItemNameLat,
  setItemCity,
} from '@/modules/Dictionary/__form/item';
import FInput from '@/plugins/form/FInput';
import FTime from '@/plugins/form/FTime';

export default class DictionaryExcursionForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'excursion';

  constructor(props = {}) {
    super(props);
    setItemCountry.bind(this)();
    setItemRegion.bind(this)();
    setItemCity.bind(this)();
    setItemName.bind(this)({ length: 300 });
    setItemNameLat.bind(this)({ length: 300 });
    setItemCode.bind(this)();

    this.setItemDuration();
    this.setItemPlaceFrom();
    this.setItemPlaceTo();
    this.setItemTimeFrom();
    this.setItemTimeTo();
    this.setItemComment();
  }

  setItemDuration() {
    this.duration = new FInput({
      name: 'Duration',
      label: 'Продолжительность',
    });
    this.duration.setValidatorMax(10);
    this.setItem('duration', this.duration);
  }

  setItemPlaceFrom() {
    this.placeFrom = new FInput({
      name: 'PlaceFrom',
      label: 'Место отправления',
    });
    this.placeFrom.setValidatorMax(50);
    this.setItem('placeFrom', this.placeFrom);
  }

  setItemPlaceTo() {
    this.placeTo = new FInput({
      name: 'PlaceTo',
      label: 'Место прибытия',
    });
    this.placeTo.setValidatorMax(50);
    this.setItem('placeTo', this.placeTo);
  }

  setItemTimeFrom() {
    this.timeFrom = new FTime({
      name: 'TimeBegin',
      label: 'Время отправления',
    });
    this.setItem('timeFrom', this.timeFrom);
  }

  setItemTimeTo() {
    this.timeTo = new FTime({
      name: 'TimeEnd',
      label: 'Время прибытия',
    });
    this.setItem('timeTo', this.timeTo);
  }

  setItemComment() {
    this.comment = new FInput({
      name: 'Comment',
      label: 'Комментарий',
    });
    this.comment.setValidatorMax(254);
    this.setItem('comment', this.comment);
  }
}
